import { EntDirectoryInfoName } from "../directoryInfoName";

export class EntUnitMeasurement {
    id: number = 0; 
    nameRu: string = "";
    nameKy: string = "";
    alias: string = "";
    measurementCategoryId?: EntDirectoryInfoName | null = null
    unitMeasurementCategoryResponse: EntDirectoryInfoName | null = null
  }
  